import type { CardTemplate } from '@nudge/shared';
import { LONG_PRESS_MS } from '@nudge/shared';

interface CardTileProps {
  template: CardTemplate;
  onClick?: () => void;
  onLongPress?: () => void;
  size?: 'compact' | 'comfortable' | 'large';
}

export function CardTile({ template, onClick, onLongPress, size = 'comfortable' }: CardTileProps) {
  let pressTimer: ReturnType<typeof setTimeout> | null = null;

  function down() {
    if (!onLongPress) return;
    pressTimer = setTimeout(() => { onLongPress(); pressTimer = null; }, LONG_PRESS_MS);
  }
  function up() {
    if (pressTimer) { clearTimeout(pressTimer); pressTimer = null; }
  }

  const padClass = size === 'compact' ? 'py-3 px-3' : size === 'large' ? 'py-6 px-4' : 'py-5 px-3';
  const iconClass = size === 'compact' ? 'text-2xl' : size === 'large' ? 'text-4xl' : 'text-3xl';
  const labelClass = size === 'compact' ? 'text-xs' : size === 'large' ? 'text-base' : 'text-sm';
  const accent = template.colour ?? undefined;

  return (
    <button
      onClick={onClick}
      onPointerDown={down}
      onPointerUp={up}
      onPointerLeave={up}
      onContextMenu={(e) => { if (onLongPress) { e.preventDefault(); onLongPress(); } }}
      className={`relative flex w-full flex-col items-center gap-1.5 rounded-2xl border border-border-subtle bg-card text-center transition-transform active:scale-95 ${padClass}`}
      style={accent ? { borderColor: accent + '60' } : undefined}
    >
      {template.is_favorite && (
        <span className="absolute right-1.5 top-1.5 text-xs leading-none text-amber" aria-label="favourite">★</span>
      )}
      <span className={iconClass} aria-hidden>{template.icon}</span>
      <span className={`${labelClass} font-medium leading-tight text-text-primary`}>{template.label}</span>
      {template.subtext && size !== 'compact' && (
        <span className="text-xs leading-tight text-text-muted">{template.subtext}</span>
      )}
    </button>
  );
}
